import * as React from 'react';
import LogoAndTitle from '@/components/LogoAndTitle';
import styles from './index.less';
import { useModel } from 'umi';
import { MenuFoldOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import SolutionSwitch from '@/components/menu/SolutionSwitch';
import { hasAccess } from '@/utils/access';
import PERMISSIONS from '@/constants/permissions';

interface MenuHeaderProps {
  logo: string;
}

const MenuHeader: React.FC<MenuHeaderProps> = ({ logo }: MenuHeaderProps) => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const isJourneySwitcherRestricted = !hasAccess(initialState?.currentUser, PERMISSIONS.BUSINESS_PARTNER);

  const solutions = initialState.solutions || [];

  return (
    <div
      className={classNames({
        [styles.menuHeader]: true,
        [styles.noBorder]: solutions.length > 1,
        [styles.collapsed]: initialState?.collapsed,
      })}
    >
      <div
        className={styles.collapseSwitch}
        onClick={() =>
          setInitialState({
            ...initialState,
            collapsed: !initialState?.collapsed,
          })
        }
      >
        <MenuFoldOutlined />
      </div>
      <div
        className={isJourneySwitcherRestricted ? styles.logoWithoutJourneySelector : styles.logo}
      >
        <LogoAndTitle logoWithType={<img style={{ width: 'calc(100% - 50px)', display: 'block', margin: '0 auto' }}
                                         src={'/logo_with_type.png'} alt="" />}
                      onlyLogo={initialState?.collapsed} containerClassName={styles.logoAndTitleContainer}
                      titleClassName={styles.title} />
      </div>
      <SolutionSwitch />
    </div>
  );
};

export default (MenuHeader);
